/**
 * api/phoneAiApi.js — 71300 УТАСНЫ AI ЯРИА
 *
 * Backend: Resources/XAB/phone_ai.py (/xab/phone-ai/*).
 */
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://hse.erdenetmc.mn/api",
});

api.interceptors.request.use((config) => {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `SSO ${token}`;
  }
  return config;
});

export const phoneAiApi = {
  status: () => api.get("/xab/phone-ai/status").then((r) => r.data),
  start: () => api.post("/xab/phone-ai/calls").then((r) => r.data),
  // ⚠ STT нь Chimege-ийн 2 алхамт (stt-long) тул нэг өгүүлбэр 2-5 сек
  //   болно — timeout-ыг багасгахгүй.
  sendAudio: (uuid, blob) => {
    const fd = new FormData();
    fd.append("audio", blob, "turn.webm");
    return api
      .post(`/xab/phone-ai/calls/${uuid}/turn`, fd, { timeout: 60000 })
      .then((r) => r.data);
  },
  sendText: (uuid, text) =>
    api.post(`/xab/phone-ai/calls/${uuid}/turn`, { text }).then((r) => r.data),
  hangup: (uuid) =>
    api.post(`/xab/phone-ai/calls/${uuid}/hangup`).then((r) => r.data),
  calls: (params) =>
    api.get("/xab/phone-ai/calls", { params }).then((r) => r.data),
  call: (uuid) => api.get(`/xab/phone-ai/calls/${uuid}`).then((r) => r.data),
  analyze: (uuid) =>
    api.post(`/xab/phone-ai/calls/${uuid}/analyze`).then((r) => r.data),
  prompt: () => api.get("/xab/phone-ai/prompt").then((r) => r.data),
  savePrompt: (data) =>
    api.put("/xab/phone-ai/prompt", data).then((r) => r.data),
  // Хариуцах нэгжийн AI санал (/hazard/triage) — Resources/XAB/route_suggest.py
  routeSuggest: (reportId, refresh) =>
    api
      .get(`/xab/route-suggest/${reportId}`, {
        params: refresh ? { refresh: 1 } : undefined,
        timeout: 40000,
      })
      .then((r) => r.data),
  routeMetrics: () => api.get("/xab/route-suggest/metrics").then((r) => r.data),
};
